<template>
    <div>
      <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
      <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="store">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.section_name" :error="form.errors.section_name" class="pb-8 pr-6 w-full lg:w-1/1" label="Name of Division" required="true" placeholder="i.e Mayor’s office"/>
            <text-input v-model="form.short_name" :error="form.errors.short_name" class="pb-8 pr-6 w-full lg:w-1/1" label="Short Name of Division" placeholder="i.e MO"/>

            <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status of Division" class="pb-8 pr-6 w-full lg:w-1/1"></status-toogle-button>
          </div>
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <Button :type="type" :name="title" :url="createUrl" :loading="form.processing"></Button>

          </div>
        </form>
      </div>
    </div>
  </template>

  <script>
  import axios from 'axios';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
  import { ref, toRefs, inject } from 'vue'
  import Layout from '@/Shared/Layout'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import StatusToogleButton from '@/Shared/StatusToogleButton'
  import Breadcrumbs from '@/Shared/Breadcrumbs'
  import SelectInputFunction from '@/Shared/SelectInputFunction'
  import Button from '@/Shared/Button'
  export default {
    components: {
      Head,
      Link,
      LoadingButton,
      SelectInput,
      TextInput,
      StatusToogleButton,
      Breadcrumbs,
      SelectInputFunction,
      Button
    },
    layout: Layout,
    remember: 'form',
    setup(){
      const form = useForm({
        section_name: null,
        short_name: null,
        hierarchy: null,
        status: true
      })
      const type = ref('create')
      const title = ref('Division')
      const url = ref('/backend/sections')
      const createUrl = ref('')
      const swal = inject('$swal')
      const store = () => {
        swal({
            title: 'Are you sure?',
            text: "You want to proceed with this action",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
          }).then((result) => {
            if (result.isConfirmed) {
              form.post(`${url.value}`, {forceFormData: true,})
              swal.fire(
                'Added!',
                'Your infomation has been Added.',
                'success'
              )
            }
          });

      }
      return {
        form,
        type,
        title,
        url,
        createUrl,
        store
      }
    }
  }
  </script>
